import React from 'react';
import { FormControl } from 'react-bootstrap';
import { I18n } from 'react-redux-i18n';

const DEFAULT_OPTION_VALUE = '';

const AffiliateRates = ({ rateTemplate, rateTemplateOptions, onChange }) => (
  <div className="network-setting-section">
    <h3 className="section-title">{
      I18n.t('networkSetting.AffiliateRates')}</h3>
    <div className="input-field-wrapper">
      <div className="input-label-row">
        <span className="input-label">
          {I18n.t('networkSetting.AffiliateRatesDes')}
        </span>
      </div>
      <FormControl
        as="select"
        className={'form-control form-custom'}
        value={rateTemplate || DEFAULT_OPTION_VALUE}
        onChange={onChange}
      >
        <option value={DEFAULT_OPTION_VALUE}>{I18n.t('networkSetting.AffiliateRatesSelect')}</option>
        {rateTemplateOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </FormControl>
    </div>
  </div>
);

export default AffiliateRates;